import isPlainObject from 'lodash/isPlainObject';
import { PLUGIN_CONFIG_DEFAULTS, PLUGIN_CONFIG_OVERRIDES } from './plugins';
import { truncateContent, isRichContent } from '@wix/ricos';
const buildConfig = (config, pluginType, internalProps) => ({
    ...PLUGIN_CONFIG_DEFAULTS(internalProps)[pluginType],
    ...config,
    ...PLUGIN_CONFIG_OVERRIDES(internalProps)[pluginType],
});
export const initEditorPlugins = (config, internalProps) => {
    if (isPlainObject(config)) {
        const exposedPluginButtons = [];
        const plugins = Object.keys(config).map((pluginType) => {
            const { editorModule, editorConfig = {} } = config[pluginType];
            if (internalProps?.disabledPlugins?.includes(pluginType)) {
                return undefined;
            }
            if (editorConfig.exposeEmbedButtons) {
                exposedPluginButtons.push(...editorConfig.exposeEmbedButtons);
            }
            if (editorConfig.exposeButtons) {
                exposedPluginButtons.push(...editorConfig.exposeButtons);
            }
            return editorModule
                ? editorModule(buildConfig(editorConfig, pluginType, internalProps))
                : undefined;
        });
        return { plugins: plugins.filter((p) => p), exposedPluginButtons };
    }
    return { plugins: [], exposedPluginButtons: [] };
};
export const initViewerPlugins = (config, internalProps) => {
    if (isPlainObject(config)) {
        const plugins = Object.keys(config).map((pluginType) => {
            const { viewerModule, viewerConfig = {} } = config[pluginType];
            return viewerModule
                ? viewerModule(buildConfig(viewerConfig, pluginType, internalProps))
                : undefined;
        });
        return plugins.filter((p) => p);
    }
    return [];
};
export const getTransformedContent = (content, { truncationThreshold }) => {
    const truncatedContent = content && truncationThreshold
        ? truncateContent(content, { wordsCount: truncationThreshold })
        : undefined;
    if (isRichContent(content)) {
        if (truncatedContent && isRichContent(truncatedContent.content)) {
            return {
                content,
                truncatedContent: truncatedContent?.isTruncated ? truncatedContent.content : undefined,
            };
        }
        return {
            content,
            truncatedContent: undefined,
        };
    }
    return {
        content: undefined,
        truncatedContent: undefined,
    };
};
//# sourceMappingURL=ricos-utils.js.map